<div
  class="flex_item_right mb-24"
  [ngClass]="isUploadScreen ? 'border-upload-screen' : ''"
  >
  <div class="header" [ngClass]="isUploadScreen ? 'classify-center' : ''">
    @if (isClassify || isPassFail) {
      <span>Classify </span>
    }
    @if (isUpdateLineNo) {
      <span>Update Line no </span>
    }
    @if (isCreateTotalDataSet) {
      <span>Create Dataset</span>
    }
    <div class="icon-close" style="text-align: end" (click)="onClose()">
      @if (!isUploadScreen) {
        <mat-icon class="close-icon">close</mat-icon>
      }
    </div>
  </div>
  @if (isClassify) {
    <div>
      <div class="tab-header">
        @if (isClassify) {
          <button
            class="btn grading-label"
            [ngClass]="isGradingSelected ? 'selectedPanelHeader' : ''"
            (click)="onGradingSelected()"
            >
            Grading
          </button>
        }
        @if (!isPassFail) {
          <button
            class="btn fm-label"
            [ngClass]="!isGradingSelected ? 'selectedPanelHeader' : ''"
            (click)="onFmSelected()"
            style="display: none"
            >
            FM Measure
          </button>
        }
      </div>
      @if (isClassify) {
        <div
          class="grading-panel"
          [ngClass]="!isGradingSelected ? 'grading-panel-hide' : ''"
          >
          <mat-radio-group
            [(ngModel)]="selectedGradeValue"
            (change)="radioChange($event)"
            >
            @if (isClassify) {
              <div>
                @for (value of gradingList; track value) {
                  <div>
                    <mat-radio-button [value]="value.value"
                      >{{ value.value }}
                      <mat-icon style="display: none">check</mat-icon>
                      <span style="display: none" class="grade-span">{{
                        value.value
                      }}</span>
                    </mat-radio-button>
                    @if (value.value === 'Fail') {
                      <div>
                        <mat-form-field
                          [ngClass]="isFail ? 'fail-reason-show' : 'fail-reason-hide'"
                          [floatLabel]="'never'"
                          >
                          <mat-label class="mat-placeholder"
                            >Failed Reason</mat-label
                            >
                            <mat-select [(ngModel)]="selectedFailedReason">
                              @for (reason of failedReason; track reason; let i = $index) {
                                <mat-option
                                  [value]="reason.value"
                                  >
                                  <mat-checkbox
                                    [checked]="selected === i"
                                    (change)="getFailedReason(reason.value); selected = i"
                                    >{{ reason.value }}</mat-checkbox
                                    >&nbsp; &nbsp; &nbsp;
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </mat-radio-group>
            </div>
          }
        </div>
      }
      @if (isPassFail) {
        <div>
          @if (isPassFail) {
            <div
              class="grading-panel"
              [ngClass]="!isGradingSelected ? 'grading-panel-hide' : ''"
              >
              <mat-radio-group
                [(ngModel)]="selectedGradeValue"
                (change)="radioChange($event)"
                >
                @if (isPassFail) {
                  <div>
                    <mat-radio-button value="Pass"
                      >Pass
                      <mat-icon style="display: none">check</mat-icon>
                      <span style="display: none" class="grade-span">Pass</span>
                    </mat-radio-button>
                    <mat-radio-button value="Fail" class="fail-radio-button">
                      Fail
                      <mat-icon style="display: none">close</mat-icon>
                      <span style="display: none" class="grade-span">Fail</span>
                    </mat-radio-button>
                    <mat-form-field
                      [ngClass]="isFail ? 'fail-reason-show' : 'fail-reason-hide'"
                      [floatLabel]="'never'"
                      >
                      <mat-label class="mat-placeholder"
                        >Failed Reason</mat-label
                        >
                        <mat-select [(ngModel)]="selectedFailedReason">
                          @for (reason of failedReason; track reason; let i = $index) {
                            <mat-option
                              [value]="reason.value"
                              >
                              <mat-checkbox
                                [checked]="selected === i"
                                (change)="getFailedReason(reason.value); selected = i"
                                >{{ reason.value }}</mat-checkbox
                                >&nbsp; &nbsp; &nbsp;
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    }
                  </mat-radio-group>
                </div>
              }
            </div>
          }
          @if (isUpdateLineNo) {
            <div>
              <div class="radio-group-wrapper">
                <mat-radio-group>
                  @for (line of lineArray; track line; let i = $index) {
                    <mat-radio-button
                      [value]="line.id"
                      (change)="onLineChange($event, line.id)"
                      >
                      {{ line.name }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            </div>
          }

          @if (isCreateTotalDataSet) {
            <div>
              <div class="form-grp">
                <label class="important"><b> Name </b></label>
                <gdx-input-box
                  class="form-control"
                  (onKeyPress)="omit_special_char($event)"
                  [type]="'text'"
                  [id]="'dataset-name'"
                  [name]="'dataset-name'"
                  [placeholder]="'Name..'"
                  [control]="'datasetName'"
                  [parentForm]="gradingFormGroup"
                  (onPaste)="onPaste($event)"
                  [autoFocus]="true"
                  >
                </gdx-input-box>
                @if (nameLoading) {
                  <span class="name-loader float-right"></span>
                }
                @if (isPresent) {
                  <label class="error" for="name"
                    >* Master Dataset name already exists</label
                    >
                  }
                  <label class="purpose"><b> Purpose </b></label>
                  <gdx-input-box
                    class="form-control"
                    [type]="'text'"
                    [id]="'dataset-purpose'"
                    [name]="'dataset-purpose'"
                    [placeholder]="'Type Purpose..'"
                    [control]="'datasetPurpose'"
                    [parentForm]="gradingFormGroup"
                    >
                  </gdx-input-box>
                  @if (isExternalStorageRequired) {
                    <div class="breadcrumbbar-btn">
                      <mat-form-field class="connection-dropdown" [floatLabel]="'never'">
                        <mat-label class="mat-placeholder">Connection</mat-label>
                        <mat-select
                          panelClass="custom-ht"
                          (selectionChange)="getConnectionSelected($event)"
                          [(ngModel)]="selectedConectionValue"
                          >
                          @for (connectionObj of allConnections; track connectionObj) {
                            <mat-option
                              [value]="connectionObj"
                              >
                              {{ connectionObj.name }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                </div>
              </div>
            }
            <div class="selected-done">
              @if (isClassify) {
                <div>
                  <div class="comment-wrapper">
                    <mat-icon class="comments-icon">comment</mat-icon>
                    <span class="comments-label">Make a comment</span>
                  </div>
                  <textarea
                    class="comments-txt-area"
                    (change)="onTextAreaChange($event.target.value)"
                    [(ngModel)]="comments"
                    >
                  </textarea>
                  @if (selectedGradeValue) {
                    <p style="font-size: 11px; margin-bottom: 2px">
                      <b>Selected Items:</b>
                    </p>
                  }
                  <div style="display: flex">
                    @if (selectedGradeValue) {
                      <p
                        class="selected-grade-label"
          [ngClass]="
            selectedGradeValue == 'Borderline'
              ? 'darkorange'
              : selectedGradeValue == 'Fail'
              ? 'red'
              : selectedGradeValue == 'Pass'
              ? 'green'
              : 'grey'
          "
                        >
                        {{ selectedGradeValue }}
                      </p>
                    }
                    @if (selectedFMMeasure) {
                      <p class="selected-fm-label">
                        {{ selectedFMMeasure }}
                      </p>
                    }
                  </div>
                </div>
              }
              <div class="done-btn-wrapper">
                <gdx-button
                  class="button button-success done-btn px-5 py-2 rounded-lg text-white"
                  [id]="'submit-button'"
                  [text]="'Submit'"
                  [tooltip]="'Submit'"
                  [disabled]="isCreateTotalDataSet && gradingFormGroup.invalid"
                  [icon]="''"
                  [iconHover]="''"
                  (clicked)="updateMetada()"
                  >
                </gdx-button>
              </div>
            </div>
          </div>
